import React, { useContext } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./View_address_modal.css";
import { Context } from "../../../../utils/context";

const View_address_modal = (props) => {
  const { IMG_URL } = useContext(Context);

  const handleDownloadInvoice = async (invoicePath) => {
    if (!invoicePath) {
      alert("Invoice not available");
      return;
    }

    try {
      const fileUrl = `${IMG_URL}${invoicePath}`;
      const fileResponse = await fetch(fileUrl);
      const blob = await fileResponse.blob();

      if (blob.type !== "application/pdf") {
        alert("Invalid invoice file");
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_address_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Order Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="mt-3 mb-3">Order Items</h5>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>Product</th>
                  <th>Variant</th>
                  <th>Qty</th>
                  <th>Selling Price</th>
                  <th>Refer Commision</th>
                  <th>Coupon Discount</th>
                  <th>Offer Discount</th>
                  <th>Total Addon</th>
                  <th>Tax</th>
                  <th>Total</th>
                  <th>Invoice</th>
                </tr>
              </thead>
              <tbody>
                {props?.data?.orders_details?.length > 0 ? (
                  props.data.orders_details.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>

                      <td>
                        <img
                          src={`${IMG_URL}${item?.product?.image1}`}
                          alt=""
                          width="50"
                          height="50"
                          style={{ objectFit: "cover" }}
                        />
                      </td>

                      <td>{item?.product?.name}</td>

                      <td>{item?.product_variant?.v_name}</td>

                      <td>{item?.quantity}</td>

                      <td>₹{item?.price}</td>

                      <td>₹{item?.refer_commision}</td>

                      <td>₹{item?.coupon_discount}</td>

                      <td>₹{item?.offer_discount}</td>
                      <td>₹{item?.total_addon}</td>

                      <td>
                        {item?.product?.product_detail?.tax_percentage?.name}%
                        (₹{item?.total_tax})
                      </td>

                      <td>₹{item?.total_amount}</td>
                      <td className="tax-name" style={{ width: "200px" }}>
                        <Button
                          className="action-btn"
                          // onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                          onClick={() => handleDownloadInvoice(item?.invoice)}
                        >
                          Print Invoice
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Products Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default View_address_modal;
